export const managerRewards = {
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "full_name": "Nombre completo",
    "title": "Recompensas para",
    "apartment": "Departamento",
    "street_and_num": "Calle (calle, número)",
    "city": "Ciudad",
    "title2": "Recompensa para la empresa de gestión",
    // todo move to separate component
    "titleMarketPlace": "Productos con descuento",
    "collect_marketplace_product": "Seleccione un producto",
    "collect_marketplace_product_success": "Has obtenido el producto con éxito",
    "collect_marketplace_title": "productos",
    "collect_marketplace_currency": "ILS",
    "collect_marketplace_popup_title": "Complete sus datos para este producto",
    "collect_marketplace_popup_explain": "el pedido se completará después de una llamada con nuestro representante",
    "actions_title": "Cuánto cuestan las acciones",
    "amount": "Cantidad de monedas",
    "prizes": "Premios",
    "action": "Acción",
    "coins_gained": "Monedas ganadas",
    "coins": "monedas",
    "collect": "Recolectar",
    "collect_prize": "Obtener premio",
    "personal_details": "Detalles personales",
    "delivery_details": "Detalles de la entrega",
    "next_prize": "Te quedan <amountLeft> monedas para alcanzar el siguiente premio",
    "prize_collect_success": "Has obtenido el premio con éxito",
    "COINS_NOT_ENOUGH": "No tienes suficientes monedas para este premio",
    "CAMPAIGN_NOT_FOUND": "Campaña no encontrada",
    "CAMPAIGN_NOT_ACTIVE": "Campaña no activa",
    "CAMPAIGN_PRIZE_NOT_FOUND": "No se encontró el premio seleccionado",
    "CAMPAIGN_PRIZE_ALREADY_REQUESTED": "Ya se solicitó el premio seleccionado",
    "new_coins_gained": "¡Felicidades, tienes {{newPoints}} monedas nuevas! Consulta la página de recompensas y selecciona el premio",
    "no_coins": "No tienes suficientes monedas para seleccionar este premio",
    "collecting_points_tooltip": "La acumulación de puntos se realizará únicamente para operaciones de nueva recogida. Es decir, por cada apartamento por el cual no se realizó ningún pago en los últimos 3 meses"
};
